import React, { useState } from 'react';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import HowItWorks from '../components/HowItWorks';
import SMSSimulation from '../components/SMSSimulation';
import IntegrationSection from '../components/IntegrationSection';
import ROICalculator from '../components/ROICalculator';
import Testimonial from '../components/Testimonial';
import PricingOffer from '../components/PricingOffer';
import FinalCTA from '../components/FinalCTA';
import Header from '../components/Header';
import Footer from '../components/Footer';
import QuizModal from '../components/QuizModal';

const Home = () => {
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Header onOpenQuiz={() => setIsQuizOpen(true)} />
      <Hero onOpenQuiz={() => setIsQuizOpen(true)} />
      <ProblemSection />
      <ROICalculator onOpenQuiz={() => setIsQuizOpen(true)} />
      <HowItWorks />
      <SMSSimulation />
      <IntegrationSection />
      <Testimonial />
      <PricingOffer onOpenQuiz={() => setIsQuizOpen(true)} />
      <FinalCTA onOpenQuiz={() => setIsQuizOpen(true)} />
      <Footer />
      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </div>
  );
};

export default Home;
